/**
 * Node configuration for the IVR Journey Visualisation.
 * Defines role mappings, colours, and reference field relationships.
 * BR-14: REQ-3, REQ-4
 */

/**
 * Maps configType to its visual role in the journey diagram.
 * Colour communicates ROLE, not specific config type.
 */
export const NODE_ROLE_MAP: Record<string, string> = {
  'dnis':           'entry',
  'menus':          'routing',
  'intents':        'routing',
  'queues':         'resolution',
  'deflections':    'resolution',
  'chats':          'resolution',
  'emails':         'resolution',
  'business-hours': 'condition',
  'holidays':       'condition',
};

/**
 * 4 semantic colours only — colour communicates role, not type.
 */
export const ROLE_COLOURS: Record<string, string> = {
  entry:      '#1A2B45',  // Dark Navy
  routing:    '#2E6DA4',  // Blue
  resolution: '#27AE60',  // Green
  condition:  '#E8890C',  // Amber
};

/**
 * Which payload fields are treated as config references for graph traversal.
 * Only string values matching an existing configId will create an edge.
 */
export const CONFIG_REFERENCE_FIELDS: Record<string, string[]> = {
  'dnis':           ['businessHoursSchedule', 'holidaySchedule', 'destinationValue'],
  'menus':          ['option1Intent', 'option2Intent', 'option3Intent', 'option4Intent', 'option5Intent', 'option6Intent', 'option7Intent', 'option8Intent'],
  'intents':        ['destinationValue'],
  'queues':         ['businessHoursSchedule', 'holidaySchedule'],
  'business-hours': [],
  'holidays':       [],
  'deflections':    [],
  'chats':          [],
  'emails':         [],
  'blocked':        [],
};

/**
 * Returns a human-readable edge label for a reference field.
 */
export function getEdgeLabel(fieldKey: string): string {
  // Menu options
  const optionMatch = fieldKey.match(/^option(\d)Intent$/);
  if (optionMatch) return `Option ${optionMatch[1]}`;

  // Schedule references
  if (fieldKey === 'businessHoursSchedule') return 'Hours check';
  if (fieldKey === 'holidaySchedule') return 'Holiday check';

  // Destination
  if (fieldKey === 'destinationValue') return '';

  return '';
}
